document.addEventListener('DOMContentLoaded', () => {
  const collectionContainer = document.querySelector('.collection-grid, #product-grid, [data-section-type*="collection"]');
  
  // ▼ 変更点1: プリロード機能のためにコンテナのチェックは残しますが、
  // クリック機能はここがnullでも動くように、ここでのreturnは一旦削除しても良いですが、
  // 安全のためプリロード用のチェックとして残し、クリックイベントは外に出します。

  const getCleanImageUrl = (url) => {
    if (!url) return '';
    let cleanUrl = url.split('?')[0];
    cleanUrl = cleanUrl.replace(/_([0-9]+x|[0-9]+x[0-9]+)\./, '.');
    return cleanUrl;
  };

  /**
   * 商品カード内のスウォッチ関連画像（メイン・ホバー）をプリロードする
   */
  const preloadSwatchImages = (productCard) => {
    const swatches = productCard.querySelectorAll('.color-swatch[data-variant-image]');
    const allImagesJson = productCard.dataset.allImages;
    let allImages = [];

    if (allImagesJson) {
      try {
        const tempEl = document.createElement('textarea');
        tempEl.innerHTML = allImagesJson;
        const decodedJson = tempEl.value;
        allImages = JSON.parse(decodedJson);
      } catch (e) {
        console.error("エラー: ホバー画像用JSONのパースに失敗しました。", e, productCard);
      }
    }

    swatches.forEach(swatch => {
      const mainImageUrl = swatch.dataset.variantImage;

      // メイン画像のプリロード
      if (mainImageUrl) {
        const img = new Image();
        img.src = mainImageUrl;
      }

      // ホバー画像のプリロード
      if (allImages.length > 0 && mainImageUrl) {
        const mainImageCleanUrl = getCleanImageUrl(mainImageUrl);
        const currentIndex = allImages.findIndex(imgUrl => getCleanImageUrl(imgUrl) === mainImageCleanUrl);

        if (currentIndex !== -1 && currentIndex + 1 < allImages.length) {
          const secondaryImageUrl = allImages[currentIndex + 1];
          if (secondaryImageUrl) {
            const secondaryImg = new Image();
            secondaryImg.src = secondaryImageUrl;
          }
        }
      }
    });
  };

  // ▼ プリロード機能の実行（コンテナがある場合のみ）
  if (collectionContainer) {
    const preloadObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          preloadSwatchImages(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px 250px 0px'
    });

    const productCards = collectionContainer.querySelectorAll('.grid-product[data-all-images]');
    productCards.forEach(card => {
      preloadObserver.observe(card);
    });
  }

  // -------------------------------------------------------
  // ▼ 変更点2: クリックイベントを document に変更（最強の修正）
  // collectionContainer ではなく document 全体を監視することで、
  // フィルター操作後やDOM構造の違いに強くなります。
  // -------------------------------------------------------
  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('.color-swatch[data-variant-id]');
    if (!swatch) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const currentCard = swatch.closest('.grid-product');
    if (!currentCard) {
      return;
    }

    const newImageUrl = swatch.dataset.variantImage;
    const targetVariantId = swatch.dataset.variantId;

    // -------------------------------------------------------
    // ▼ 変更点3: 画像セレクタの強化
    // 元のクラスで見つからない場合、汎用的なクラスでも探すようにフォールバックを追加
    // -------------------------------------------------------
    let imageToUpdate = currentCard.querySelector('.grid-product__image-mask img');
    if (!imageToUpdate) {
        // 見つからない場合の保険（Archetypeテーマの別パターンなど）
        imageToUpdate = currentCard.querySelector('.grid__image-contain img, .image-wrap img');
    }

    if (imageToUpdate && newImageUrl) {
      imageToUpdate.src = newImageUrl;
      imageToUpdate.srcset = newImageUrl;
      // lazyload対策
      if(imageToUpdate.dataset.src) imageToUpdate.dataset.src = newImageUrl;
      if(imageToUpdate.dataset.srcset) imageToUpdate.dataset.srcset = newImageUrl;
    }

    // リンク（URL）の更新
    const mainLink = currentCard.querySelector('.grid-product__link');
    if (mainLink && targetVariantId) {
      const baseUrl = mainLink.href.split('?')[0];
      mainLink.href = `${baseUrl}?variant=${targetVariantId}`;
    }

    // ホバー画像の更新（元のロジックを維持）
    const allImagesJson = currentCard.dataset.allImages;
    if (allImagesJson) {
      try {
        const tempEl = document.createElement('textarea');
        tempEl.innerHTML = allImagesJson;
        const decodedJson = tempEl.value;
        const allImages = JSON.parse(decodedJson);

        const newImageCleanUrl = getCleanImageUrl(newImageUrl);
        const currentIndex = allImages.findIndex(imgUrl => getCleanImageUrl(imgUrl) === newImageCleanUrl);

        let secondaryImageUrl = null;
        if (currentIndex !== -1 && currentIndex + 1 < allImages.length) {
          secondaryImageUrl = allImages[currentIndex + 1];
        }

        const targetImageElement = currentCard.querySelector('.grid-product__secondary-image image-element img');
        if (targetImageElement) {
          if (secondaryImageUrl) {
            targetImageElement.src = secondaryImageUrl;
            targetImageElement.srcset = secondaryImageUrl;
            targetImageElement.style.display = '';
          } else {
              targetImageElement.style.display = 'none';
          }
        }
      } catch (e) {
        console.error("エラー: ホバー画像の処理中に問題が発生しました。", e);
      }
    }
  }, true); // useCapture: true で確実にイベントを拾う
});